import { useCallback, useEffect, useState } from 'react';

import {
  getCollapsedNavSections,
  toggleCollapsedNavSection,
} from '@/lib/localStorage/navCollapsedSections';

export function useNavCollapsedSections(orgId: string | undefined): {
  collapsedSections: Set<string>;
  toggle: (sectionId: string) => void;
} {
  const [collapsedSections, setCollapsedSections] = useState<Set<string>>(() =>
    getCollapsedNavSections(orgId)
  );

  useEffect(() => {
    setCollapsedSections(getCollapsedNavSections(orgId));
  }, [orgId]);

  const toggle = useCallback(
    (sectionId: string) => {
      if (orgId) {
        setCollapsedSections(toggleCollapsedNavSection(orgId, sectionId));
        return;
      }
      // No org in context: update local state only, skip persistence (mirrors useDashboardSectionPref).
      setCollapsedSections(prev => {
        const next = new Set(prev);
        if (next.has(sectionId)) {
          next.delete(sectionId);
        } else {
          next.add(sectionId);
        }
        return next;
      });
    },
    [orgId]
  );

  return { collapsedSections, toggle };
}
